import React from 'react';
import { Table, TableBody, TableCell, TableHead, TableRow, Typography, Link } from '@mui/material';

/**
 * Compact ranked table for name/count lists.
 * `renderName` may return a node (e.g. a link) for the name cell.
 */
const TopTable = ({ rows = [], nameLabel = 'Name', countLabel = 'Count', renderName, emptyText = 'No data in this range' }) => {
  if (!rows.length) return <Typography variant="body2" color="text.secondary">{emptyText}</Typography>;
  return (
    <Table size="small">
      <TableHead>
        <TableRow>
          <TableCell sx={{ width: 32 }}>#</TableCell>
          <TableCell>{nameLabel}</TableCell>
          <TableCell align="right">{countLabel}</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {rows.map((r, i) => (
          <TableRow key={r.name} hover>
            <TableCell>{i + 1}</TableCell>
            <TableCell sx={{ wordBreak: 'break-all' }}>{renderName ? renderName(r) : r.name}</TableCell>
            <TableCell align="right" sx={{ fontWeight: 600 }}>{r.count}</TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
};

export const mitreUrl = (technique) => `https://attack.mitre.org/techniques/${technique.replace(/\./g, '/')}/`;

export const MitreLink = ({ technique }) => (
  <Link href={mitreUrl(technique)} target="_blank" rel="noopener noreferrer" underline="hover">{technique}</Link>
);

export default TopTable;
